import type { TOC } from '@ember/component/template-only';
import type { Signature as ProviderSig } from 'parog-web/components/forc/provider';

export default <template>
  <div class='field'>
    <@form.Dropdown
      @propertyName='transplantedOrgan'
      @labelName='Type de greffe'
      @translationKey='pathology.transplanted-organ'
      as |dropdown|
    >
      <dropdown.Item @key='bipulmonary' />
      <dropdown.Item @key='monopulmonary' />
      <dropdown.Item @key='lung-heart' />
      <dropdown.Item @key='liver-lung' />
      <dropdown.Item @key='lung-kidney' />
      <dropdown.Item @key='' @value='Non renseigné' />
    </@form.Dropdown>
  </div>

  <div class='two fields' data-test-transplant-date-section>
    <div class='field'>
      <@form.Date
        @labelName='Date de la greffe'
        @propertyName='transplantDate'
      />
    </div>
    <div class='field'>
      <label>
        Rang de la greffe
      </label>
      <div class='four unstackable fields'>
        <@form.BasicRadioGroup @propertyName='transplantRank' as |Group|>
          <Group.FieldRadio @label='1' @value='1' />
          <Group.FieldRadio @label='2' @value='2' />
          <Group.FieldRadio @label='3' @value='3' />
          <Group.FieldRadio @label='4' @value='4' />
        </@form.BasicRadioGroup>
      </div>
    </div>
  </div>

  <div class='field'>
    <@form.Dropdown
      @labelName='Maladie sous-jacente'
      @propertyName='underlyingDisease'
      @translationKey='pathology.underlying-disease'
      @allowAdditions={{true}}
      as |dropdown|
    >
      <dropdown.Item
        @value="Fibrose pulmonaire d'origine toxique, médicamenteuse ou immunologique"
        @key='pulmonary_fibrosis'
      />
      <dropdown.Item @value='Mucoviscidose' @key='cystic_fibrosis' />
      <dropdown.Item
        @value='Maladies obstructives des voies aériennes'
        @key='obstructive_diseases'
      />
    </@form.Dropdown>
  </div>
</template> satisfies TOC<{
  Args: {
    form: ProviderSig['Blocks']['content'][0];
  };
}>;
